import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import PageContentLoading from "../components/PageContentLoading";
import ChangePassword from "../pages/ChangePassword";
import useMenu from "../utils/Hooks/useMenu";
import useLocale from "../utils/Hooks/useLocale";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "ChangePassword",
  };
  const screenName = 130
  const locale = useLocale(screenName);

  return (
    <LocalizationContext.Provider value={{ locale: locale }}>
      <ValidateURL currentPage={currentPage}>
        <NavBar
          screenName={screenName}
          moduleName={5}
          MenuOptions={menu}
          currentPage={currentPage}
        >
          {locale ? <ChangePassword /> : <PageContentLoading />}
        </NavBar>
      </ValidateURL>
    </LocalizationContext.Provider>
  );
};
